








import { ciTelephone } from '~/icons/source/regular/telephone.ts'
import { ciMobile } from '~/icons/source/regular/mobile.ts'
import { ciFax } from '~/icons/source/regular/fax.ts'
import { ciImported } from '~/icons/source/regular/imported.ts'
import { ciMessage } from '~/icons/source/regular/message.ts'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      icons: {
        phone: ciTelephone,
        mobile: ciMobile,
        fax: ciFax,
        mail: ciMessage,
        site: ciImported
      }
    }
  }
})
